var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaintBarthelemy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4780 1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 0.5,
    transform: "translate(4780 -1166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5,0H7A0,0,0,0,1,7,0V14a0,0,0,0,1,0,0H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
    transform: "translate(4780 -1166)",
    fill: "#00338f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H6.5A.5.5,0,0,1,7,.5v13a.5.5,0,0,1-.5.5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(4793 -1166)",
    fill: "#dd4349"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaintBarthelemy);
export default __webpack_public_path__ + "static/media/Saint-Barthelemy.18393c76e8d4133756e112972e1be2a7.svg";
export { ForwardRef as ReactComponent };